export enum TIPO_GLOSA_SAT {
    AFILIACIONES,
    NOVEDADES,
    MORA
}

export const estiloFilasXLS = (fila: number) => {
    if(fila % 2 === 0) {
        return {
            font: { sz: '11' }, 
            alignment: { horizontal: 'left' },
            fill: {patternType: 'solid', fgColor: {rgb: 'DEE7F2'}},
        };
    } else {
        return {
            font: { sz: '11' }, 
            alignment: { horizontal: 'left' } 
        };
    }
};

const estiloCabeceraXLS = {
    alignment: { horizontal: 'left' },
    font: {sz: '11', bold: true, color: {rgb: 'FFFFFF'}},
    fill: {patternType: 'solid', fgColor: {rgb: '1E90FF'}},
    border: {bottom: {style: 'thin', color: {rgb: '000000'}}, right: {style: 'thin', color: {rgb: '000000'}}},
};

const TituloCabeceraGlosas = [
    {titulo: "NIT EMPLEADOR",       tamaño: 14, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "PÓLIZA",              tamaño: 9,  tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "ESTADO PÓLIZA",       tamaño: 13, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "NOMBRE EMPLEADOR",    tamaño: 40, tipo: [TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "UEN",                 tamaño: 22, tipo: [TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "TIPO TRANSACCIÓN",    tamaño: 26, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "SERVICIO",            tamaño: 8,  tipo: [TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "CONSECUTIVO",         tamaño: 12, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "FECHA OPERACIÓN",     tamaño: 15, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "ESTADO",              tamaño: 12, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "USUARIO PROCESO",     tamaño: 16, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "CORREO USUARIO",      tamaño: 24, tipo: [TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "GLOSA",               tamaño: 6,  tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "PERIODO",             tamaño: 12, tipo: [TIPO_GLOSA_SAT.MORA]},
    {titulo: "TIPO REPORTE",        tamaño: 12, tipo: [TIPO_GLOSA_SAT.MORA]},
    {titulo: "DESCRIPCIÓN GLOSA",   tamaño: 52, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "DETALLE GLOSA",       tamaño: 20, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "RESPUESTA SAT",       tamaño: 20, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "FUENTE INGRESO",      tamaño: 14, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "GLOSA BLOQUEANTE",    tamaño: 17, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]},
    {titulo: "OBSERVACIÓN GESTIÓN", tamaño: 25, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES, TIPO_GLOSA_SAT.MORA]}
];

export const cabeceraGlosasSAT = (tipoGlosa: TIPO_GLOSA_SAT) => {
    return (
        TituloCabeceraGlosas.filter(cabeceras => (cabeceras.tipo.indexOf(tipoGlosa) > -1)).map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraRespuestaGestionGlosas = [
    {titulo: "NIT EMPLEADOR",       tamaño: 14, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "PÓLIZA",              tamaño: 9,  tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "ESTADO PÓLIZA",       tamaño: 13, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "NOMBRE EMPLEADOR",    tamaño: 28, tipo: [TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "TIPO TRANSACCIÓN",    tamaño: 26, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "SERVICIO",            tamaño: 10, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "CONSECUTIVO",         tamaño: 12, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "FECHA OPERACIÓN",     tamaño: 15, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "GLOSA BLOQUEANTE",    tamaño: 17, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "GLOSA",               tamaño: 6,  tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "DESCRIPCIÓN GLOSA",   tamaño: 35, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "DETALLE GLOSA",       tamaño: 20, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "RESPUESTA SAT",       tamaño: 20, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "USUARIO GESTIÓN",     tamaño: 15, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "OBSERVACIÓN GESTIÓN", tamaño: 20, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "PROCESO",             tamaño: 10, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "MENSAJE PETICIÓN",    tamaño: 18, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "CÓDIGO ERROR",        tamaño: 13, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
    {titulo: "RESPUESTA ERROR",     tamaño: 36, tipo: [TIPO_GLOSA_SAT.AFILIACIONES, TIPO_GLOSA_SAT.NOVEDADES]},
];

export const cabeceraRespuestaGestionGlosas = (tipoGlosa: TIPO_GLOSA_SAT) => {
    return(
        TituloCabeceraRespuestaGestionGlosas.filter(cabeceras => (cabeceras.tipo.indexOf(tipoGlosa) > -1)).map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraDatosBasicosEstructuraEmpresas = [
    {titulo: "NIT EMPLEADOR",           tamaño: 15},
    {titulo: "RAZÓN SOCIAL",            tamaño: 30},
    {titulo: "PÓLIZA",                  tamaño: 9},
    {titulo: "INICIO COBERTURA",        tamaño: 16},
    {titulo: "TIPO PERSONA",            tamaño: 12},
    {titulo: "NATURALEZA JURIDICA",     tamaño: 18},
    {titulo: "ACTIVIDAD ECONOMICA",     tamaño: 19},
    {titulo: "TIPO APORTANTE",          tamaño: 14},
    {titulo: "CLASE APORTANTE",         tamaño: 15},
    {titulo: "CORREO ELÉCTRONICO",      tamaño: 22},
    {titulo: "DOCUMENTO REPR. LEGAL",   tamaño: 21},
    {titulo: "NOMBRE REPR. LEGAL",      tamaño: 21},
    {titulo: "SEDES",                   tamaño: 5},
    {titulo: "CENTROS DE TRABAJO",      tamaño: 17},
    {titulo: "EMPLEADOS",               tamaño: 10}
];

export const cabeceraDatosBasicosEstructuraEmpresas = () => {
    return (
        TituloCabeceraDatosBasicosEstructuraEmpresas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraSedesEstructuraEmpresas = [
    {titulo: "NIT EMPLEADOR",           tamaño: 14},
    {titulo: "CÓDIGO SEDE",             tamaño: 12},
    {titulo: "NOMBRE SEDE",             tamaño: 15},
    {titulo: "SEDE PRINCIPAL",          tamaño: 14},
    {titulo: "MUNICIPIO SEDE",          tamaño: 15},
    {titulo: "DIRECCIÓN SEDE",          tamaño: 20},
    {titulo: "ZONA UBICACIÓN",          tamaño: 15},
    {titulo: "TELÉFONO",                tamaño: 13},
    {titulo: "CORREO",                  tamaño: 24},
    {titulo: "DOC. RESPONSABLE",        tamaño: 16},
    {titulo: "NOMBRE RESPONSABLE",      tamaño: 32},
    {titulo: "SEDE EMPLEADOR MISIÓN",   tamaño: 21},
    {titulo: "EMPLEADOR MISIÓN",        tamaño: 18},
    {titulo: "CENTROS TRABAJO",         tamaño: 15},
    {titulo: "TOTAL EMPLEADOS",         tamaño: 15}
];

export const cabeceraSedesEstructuraEmpresas = () => {
    return (
        TituloCabeceraSedesEstructuraEmpresas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraCentrosTrabajoEstructuraEmpresas = [
    {titulo: "NIT EMPLEADOR",           tamaño: 14},
    {titulo: "CÓDIGO SEDE",             tamaño: 11},
    {titulo: "CÓDIGO CENTRO TRABAJO",   tamaño: 21},
    {titulo: "NOMBRE CENTRO TRABAJO",   tamaño: 22},
    {titulo: "ACTIVIDAD ECONÓMICA",     tamaño: 19},
    {titulo: "MUNICIPIO",               tamaño: 12},
    {titulo: "DIRECCIÓN",               tamaño: 22},
    {titulo: "ZONA UBICACIÓN",          tamaño: 15},
    {titulo: "TELÉFONO",                tamaño: 12},
    {titulo: "CORREO",                  tamaño: 24},
    {titulo: "DOC. RESPONSABLE",        tamaño: 18},
    {titulo: "NOMBRE RESPONSABLE",      tamaño: 28},
    {titulo: "TOTAL EMPLEADOS",         tamaño: 15}
];

export const cabeceraCentrosTrabajoEstructuraEmpresas = () => {
    return (
        TituloCabeceraCentrosTrabajoEstructuraEmpresas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraEmpleadosEstructuraEmpresas = [
    {titulo: "NIT EMPLEADOR",           tamaño: 14},
    {titulo: "CÓDIGO SEDE",             tamaño: 11},
    {titulo: "CÓDIGO CENTRO TRABAJO",   tamaño: 21},
    {titulo: "DOC. EMPLEADO",           tamaño: 20},
    {titulo: "NOMBRE EMPLEADO",         tamaño: 35},
    {titulo: "INICIO COBERTURA",        tamaño: 15},
    {titulo: "FIN COBERTURA",           tamaño: 13},
    {titulo: "TIPO COTIZANTE",          tamaño: 13},
    {titulo: "SUBTIPO COTIZANTE",       tamaño: 16},
    {titulo: "IBC",                     tamaño: 10},
    {titulo: "TIPO SALARIO",            tamaño: 12},
    {titulo: "FECHA NACIMIENTO",        tamaño: 16},
    {titulo: "SEXO",                    tamaño: 5},
    {titulo: "EPS",                     tamaño: 8},
    {titulo: "AFP",                     tamaño: 8}
];

export const cabeceraEmpleadosEstructuraEmpresas = () => {
    return (
        TituloCabeceraEmpleadosEstructuraEmpresas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteMoraSAT = [
    {titulo: "CODIGO ARL",          tamaño: 15},
    {titulo: "TIPO DOCUMENTO",      tamaño: 20},
    {titulo: "NUMERO DOCUMENTO",    tamaño: 20},
    {titulo: "CONSECUTIVO NIT",     tamaño: 15},
    {titulo: "PERIODO MORA",        tamaño: 15}
];

export const cabeceraReporteMoraSAT = () => {
    return (
        TituloCabeceraReporteMoraSAT.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteEmpresasSAT = [
    {titulo: "TIPO DOCUMENTO",          tamaño: 15},
    {titulo: "NUMERO DOCUMENTO",        tamaño: 15},
    {titulo: "CONSECUTIVO NIT",         tamaño: 15},
    {titulo: "FECHA SOLICITUD",         tamaño: 15},
    {titulo: "FECHA FIN AFILIACION",    tamaño: 15},
    {titulo: "TIPO REPORTE",            tamaño: 15},
    {titulo: "POLIZA",                  tamaño: 15},
    {titulo: "DNI EMPLEADOR",           tamaño: 15},
    {titulo: "FECHA ALTA",              tamaño: 15},
    {titulo: "FECHA BAJA",              tamaño: 15},
    {titulo: "ESTADO SURA",             tamaño: 15}
];

export const cabeceraReporteEmpresasSAT = () => {
    return (
        TituloCabeceraReporteEmpresasSAT.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteGeneralGlosas = [
    {titulo: "SERVICIO",            tamaño: 30},
    {titulo: "RESPUESTA OK",        tamaño: 20},
    {titulo: "RESPUESTA GLOSA",     tamaño: 20},
    {titulo: "RESPUESTA ERROR",     tamaño: 15}
];

export const cabeceraReporteGeneralGlosas = () => {
    return (
        TituloCabeceraReporteGeneralGlosas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteDetalleGlosas = [
    {titulo: "SERVICIO",            tamaño: 30},
    {titulo: "GLOSA",               tamaño: 20},
    {titulo: "CANTIDAD",            tamaño: 20},
    {titulo: "DESCRIPCIÓN",         tamaño: 150}
];

export const cabeceraReporteDetalleGlosas = () => {
    return (
        TituloCabeceraReporteDetalleGlosas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteTrasladoEmpresas = [
    {titulo: "CONSECUTIVO",             tamaño: 20},
    {titulo: "DNI EMPLEADOR",           tamaño: 20},
    {titulo: "CANAL INGRESO",           tamaño: 20},
    {titulo: "MENSAJE TRASLADO",        tamaño: 30},
    {titulo: "RESPUESTA TRASLADO",      tamaño: 30},
    {titulo: "MENSAJE MORA",            tamaño: 30},
    {titulo: "RESPUESTA MORA",          tamaño: 30},
    {titulo: "EMPRESA TRASLADABLE",     tamaño: 20},
    {titulo: "CAUSAL",                  tamaño: 20},
    {titulo: "TIPO EXCEPCION",          tamaño: 20},
    {titulo: "ARL AFILIACION",          tamaño: 20},
    {titulo: "RESPUESTA SURA",          tamaño: 30},
    {titulo: "ESTADO",                  tamaño: 20},
    {titulo: "FECHA PROCESO",           tamaño: 20},
    {titulo: "OBSERVACION",             tamaño: 30},
    {titulo: "DNI PROCESO",             tamaño: 20}
];

export const cabeceraReporteTrasladoEmpresas = () => {
    return (
        TituloCabeceraReporteTrasladoEmpresas.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteHistoricoMensajes = [
    {titulo: "CONSECUTIVO MENSAJE",             tamaño: 20},
    {titulo: "CONSECUTIVO SERVICIO",            tamaño: 20},
    {titulo: "NOMBRE SERVICIO",                 tamaño: 20},
    {titulo: "DNI EMPLEADOR",                   tamaño: 30},
    {titulo: "POLIZA",                          tamaño: 30},
    {titulo: "CODIGO SEDE",                     tamaño: 30},
    {titulo: "CODIGO CENTRO TRABAJO",           tamaño: 30},
    {titulo: "DNI AFILIADO",                    tamaño: 20},
    {titulo: "PERIODO",                         tamaño: 20},
    {titulo: "MENSAJE ORIGINAL",                tamaño: 20},
    {titulo: "MENSAJE ENVIOSAT",                tamaño: 20},
    {titulo: "MENSAJE RESPUESTA SAT",           tamaño: 30},
    {titulo: "FECHA MENSAJE ORIGINAL",          tamaño: 20},
    {titulo: "FECHA MENSAJE ENVIO SAT",         tamaño: 20},
    {titulo: "FECHA MENSAJE RESPUESTA SAT",     tamaño: 30},
    {titulo: "ERROR",                           tamaño: 20},
    {titulo: "EXITOSO",                         tamaño: 20},
    {titulo: "ESTADO",                          tamaño: 20},
    {titulo: "MOTIVO RECHAZO",                  tamaño: 20},
    {titulo: "FECHA INGRESA",                   tamaño: 20},
    {titulo: "REPROCESADO",                     tamaño: 20},
    {titulo: "OBSERVACION",                     tamaño: 20},

];

export const cabeceraReporteHistoricoMensajes = () => {
    return (
        TituloCabeceraReporteHistoricoMensajes.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

const TituloCabeceraReporteResumenReciboSAT = [
    { titulo: "CONSECUTIVO",            tamaño: 20 },
    { titulo: "CONSECUTIVO SOLICITUD",  tamaño: 20 },
    { titulo: "NOMBRE SERVICIO",        tamaño: 20 },
    { titulo: "MENSAJE RECIBIDO SAT",   tamaño: 20 },
    { titulo: "MENSAJE RESPUESTA SURA", tamaño: 20 },
    { titulo: "ESTRUCTURA VALIDA",      tamaño: 20 },
    { titulo: "MENSAJE RESPUESTA",      tamaño: 20 },
    { titulo: "CODIGO",                 tamaño: 20 },
    { titulo: "FECHA INGRESO SAT",      tamaño: 20 },
    { titulo: "FECHA RESPUESTA SURA",   tamaño: 20 },
    { titulo: "FECHA INGRESA SISTEMA",  tamaño: 20 },
    { titulo: "ESTADO",                 tamaño: 20 }
];

export const cabeceraReporteResumenReciboSAT = () => {
    return (
        TituloCabeceraReporteResumenReciboSAT.map(
            cabecera => {
                return { title: cabecera.titulo, width: { wch: cabecera.tamaño }, style: estiloCabeceraXLS };
            }
        )
    );
};

const TituloCabeceraReporteDetalleReciboSAT = [
    { titulo: "CONSECUTIVO DETALLE",            tamaño: 20 },
    { titulo: "CONSECUTIVO RESUMEN",            tamaño: 20 },
    { titulo: "CONSECUTIVO RESPUESTA SAT",      tamaño: 20 },
    { titulo: "DNI EMPLEADOR",                  tamaño: 20 },
    { titulo: "USUARIO TRANSACCION SAT",        tamaño: 20 },
    { titulo: "NOMBRE USUARIO TRANSACCION SAT", tamaño: 20 },
    { titulo: "FECHA INGRESO SAT",              tamaño: 20 },
    { titulo: "ESTADO",                         tamaño: 20 },
    { titulo: "OBSERVACION",                    tamaño: 20 },
    { titulo: "ERROR",                          tamaño: 20 },
    { titulo: "DNI PROCESA SURA",               tamaño: 20 },
    { titulo: "FECHA PROCESA SURA",             tamaño: 20 },
    { titulo: "ES REPROCESADO",                 tamaño: 20 },
    { titulo: "NUMERO REPROCESO",               tamaño: 20 },
    { titulo: "DNI REPROCESA SURA",             tamaño: 20 },
    { titulo: "FECHA REPROCESA SURA",           tamaño: 20 },
    { titulo: "FECHA INGRESA SISTEMA",          tamaño: 20 }

];

export const cabeceraReporteDetalleReciboSAT = (columnas: Array<string>) => {
    const encabezados = columnas.map(encabezado => ({ titulo: encabezado.toUpperCase(), tamaño: 20 }));
    return (
        TituloCabeceraReporteDetalleReciboSAT.concat(encabezados).map(
            cabecera => {
                return { title: cabecera.titulo, width: { wch: cabecera.tamaño }, style: estiloCabeceraXLS };
            }
        )
    );
};

const TituloCabeceraReporteEnvioManualMora = [
    {titulo: "CONSECUTIVO",             tamaño: 15},
    {titulo: "CONSECUTIVO PROCESO",     tamaño: 15},
    {titulo: "DNI",                     tamaño: 15},
    {titulo: "POLIZA",                  tamaño: 15},
    {titulo: "PERIODO",                 tamaño: 15},
    {titulo: "DNI INGRESO",             tamaño: 15},
    {titulo: "FECHA INGRESO",           tamaño: 15},
    {titulo: "CONSECUTIVO MARCA",       tamaño: 15},
    {titulo: "FECHA ENVIO SAT",         tamaño: 15},
    {titulo: "FECHA DESMARCA SAT",      tamaño: 15},
    {titulo: "CONSECUTIVO DESMARCA",    tamaño: 15},
    {titulo: "VALOR NOTAS",             tamaño: 15},
    {titulo: "TIPO MORA",               tamaño: 15},
    {titulo: "JUSTIFICACION MARCA",     tamaño: 15},
    {titulo: "DNI DESMARCA",            tamaño: 15},
    {titulo: "JUSTIFICACION DESMARCA",  tamaño: 15},
    {titulo: "TIPO REGISTRO",           tamaño: 15},
    {titulo: "DETALLE ENVIO MARCA",     tamaño: 15},
    {titulo: "DETALLE ENVIO DESMARCA",  tamaño: 15}
];

export const cabeceraReporteEnvioManualMora = () => {
    return (
        TituloCabeceraReporteEnvioManualMora.map(
            cabecera => {
                return {title: cabecera.titulo, width: {wch: cabecera.tamaño}, style: estiloCabeceraXLS};
            }
        )
    );
};

export interface LibroDocumentoXLS {
    nombreLibro: string,
    cabecera: Array<any>,
    datos: Array<any>
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/modelo/PlanillasXLS.ts